<template>
  <main class="page-apis page-main__wrapper layout">
    <!-- 条件查询部分 -->
    <section class="filter-box">
      <div class="top-btns">
        <el-button @click="$_batch" class="btn__add">批量对接</el-button>
        <el-button class="btn__add" @click="$_showSelectSupplier()">批量关联供应商</el-button>
      </div>
      <el-form :inline="true" class="filter-form">
        <el-form-item label="接口名称:">
          <el-input v-model="filter.apiName"></el-input>
        </el-form-item>

        <el-form-item label="actionName:">
          <el-input v-model="filter.actionName"></el-input>
        </el-form-item>

        <el-form-item label="发送类型:">
          <el-select v-model="filter.sendType" placeholder="请选择类型">
            <el-option
              v-for="item in filter.sendTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button @click="$_search" class="search__btn">查询</el-button>
          <el-button @click="$reset ()" class="reset__btn">重置</el-button>
        </el-form-item>
      </el-form>
    </section>

    <main class="table-box">
      <!-- 数据列表 -->
      <el-table
        class="table-list__box"
        ref="tableList"
        :data="dataList"
        v-loading="isLoading"
        :height="tableHeight"
        :rowClassName="$_getRowClass"
        stripe
        border
        tooltip-effect="dark"
        @selection-change="$_handleSelectionChange"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column label="操作" width="260" :resizable="false">
          <template slot-scope="scope">
            <el-button class="edit__btn" @click="$_edit(scope.row)">编辑</el-button>
            <el-button class="edit__btn" @click="$_showSelectSupplier(scope.row)">配置已使用供应商</el-button>
          </template>
        </el-table-column>

        <el-table-column
          v-for="column in columns"
          :key="column.key"
          :prop="column.key"
          :label="column.label"
          :width="column.width"
          sortable
          show-overflow-tooltip
          filter-placement="bottom"
          v-if="!column.component"
        ></el-table-column>
        <el-table-column
          :prop="column.key"
          :label="column.label"
          :width="column.width"
          sortable
          v-else
        >
          <template slot-scope="scope">
            <component :is="column.component" :row="scope.row"></component>
          </template>
        </el-table-column>
        <el-table-column></el-table-column>
        <div class="table-list__empty" slot="empty">列表暂无数据</div>
      </el-table>
    </main>
    <!-- 分页 -->
    <div class="pagination__wrapper">
      <cd-pagination
        ref="pager"
        :total="pagination.total"
        :currPage="pagination.pageNow"
        :pageSize="pagination.pageSize"
        @changepage="$_changeCurrent"
        @changesize="$_changeSize"
        :explainShow="true"
        @refresh="$_getApis"
      ></cd-pagination>
    </div>
    <!-- 编辑 -->
    <modal-modify
      v-if="modal.show && modal.template === 'modify'"
      :title="modal.title"
      :modalData="modal.data"
      @callback="$_callback"
      @close="$_close"
    ></modal-modify>

    <!-- 批量对接 -->
    <modal-batch 
      v-if="modal.show && modal.template === 'batch'"
      :title="modal.title"
      :modalData="modal.data"
      @callback="$_callback"
      @close="$_close"
    ></modal-batch>

    <!-- 供应商 -->
    <select-supplier
      v-if="modal.show && modal.template === 'select-supplier'"
      :title="modal.title"
      :modalData="modal.data"
      @callback="$_callbackSupper"
      @close="$_close"
    ></select-supplier>
  </main>
</template>

<script>
import resize from "@/mixins/resize";
import ModalModify from "./modal-modify";
import modalBatch from './modal-batch'
import SelectSupplier from "./modal-select-supplier";

const columns = [
  { key: "pid", label: "接口ID", width: 100 },
  { key: "apiName", label: "接口名称", width: 280 },
  {
    key: "sendType",
    label: "发送类型",
    width: 120,
    component: "sendTypeTmpl"
  },
  { key: "actionName", label: "Action Name", width: 280 },
  { key: "creatorName", label: "创建人", width: 120 },
  { key: "createTime", label: "创建时间", width: 160 },
  { key: "operatorName", label: "最后编辑人", width: 120 },
  { key: "updateTime", label: "最后编辑时间", width: 160 }
];
export default {
  name: "apis-intergration-system",
  mixins: [resize],
  data() {
    return {
      filter: {
        apiName: "",
        actionName: "",
        sendTypes: [
          { value: 0, label: "全部" },
          { value: 1, label: "转发" },
          { value: 2, label: "分发" },
          { value: 3, label: "仅接收" }
        ],
        sendType: 0, // 0: 全部, 1: 转发, 2: 分发, 3: 仅接收
      },
      tableHeight: null,
      isLoading: false,
      dataList: [],
      portList: [],
      columns,
      modal: {
        show: false,
        title: "",
        template: "",
        data: {}
      },
      pagination: {
        pageNow: 1,
        pageSize: 20,
        pages: 0,
        total: 0
      },
    };
  },

  methods: {
    // 搜索
    $_search() {
      this.pagination.pageNow = 1;
      this.$_getApis();
    },
    // 重置
    $reset() {
      this.filter.apiName = "";
      this.filter.actionName = "";
      this.filter.sendType = 0;
      this.pagination.pageNow = 1;
      this.pagination.pageSize = 20;
      this.$_getApis();
    },
    // 查询接口列表
    $_getApis() {
      // this.dataList.splice(0);
      this.isLoading = true;
      this.$refs.tableList.clearSort();
      const postData = {
        apiName: this.filter.apiName,
        actionName: this.filter.actionName,
        sendType: this.filter.sendType,
        pageNow: this.pagination.pageNow,
        pageSize: this.pagination.pageSize
      };
      this.$service.post("portDockingInfoPaging", postData).then(result => {
        if (result.$.checkResult(result, true)) {
          // this.pagination.pageNow = result.data.page;
          // this.pagination.pageSize = result.data.pageSize;
          this.pagination.pages = result.data.pages;
          this.pagination.total = result.data.total;
          this.dataList = result.data.rows.concat([]);
        }
        this.isLoading = false;
      });
    },
    // 新增/编辑接口成功回调
    $_callback() {
      // this.$_close();
      this.$_getApis();
    },
    // 关闭弹窗
    $_close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.type = "add";
      this.modal.data = {};
      this.modal.title = "";
    },
    // 编辑
    async $_edit(row) {
      this.isLoading = true;
      this.modal.template = "modify";
      this.modal.title = "编辑系统对接";
      this.$service.post("portDockingInfoDetail", {pid: row.pid}).then(result => {
        this.isLoading = false;
        if (result.$.checkResult(result, true)) {
          this.modal.data = JSON.parse(JSON.stringify(result.data));
          this.modal.show = true;
        }
      });
    },
    // 计算状态为停用行的className
    $_getRowClass({ row, rowIndex }) {
      if (row.status === 2) {
        return "is-blocked";
      }
    },
    // 切换每页size
    $_changeSize(page, size) {
      this.pagination.pageSize = size;
      this.pagination.pageNow = 1;
      this.$_getApis();
    },
    // 切换当前页
    $_changeCurrent(val) {
      this.pagination.pageNow = val;
      this.$_getApis();
    },

    // 手动选择 rows[]: 需要操作的rrows
    $_toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.tableList.toggleRowSelection(row);
        });
      } else {
        this.$refs.tableList.clearSelection();
      }
    },
    // 选择的行有变化时 val[]: 已选择行数据
    $_handleSelectionChange(section) {
      this.portList = section.map(ele => ele.pid)
    },
    // 批量对接
    $_batch(){
      if(this.portList.length === 0){
        $MessageBox.alert({ content: "请选择接口!" });
        return false;
      }
      this.modal.show = true;
      this.modal.template = "batch";
      this.modal.data = this.portList;
      this.modal.title = "批量操作对接系统";
    },
    // 批量配置
    //批量配置-选择供应商
    async $_showSelectSupplier(row){
      if (this.portList.length > 0 || row) {
        let supplierList = []
        if(row){
          await this.$service.post("queryAssociateSupplier", {pid: row.pid}).then(result => {
            if (result.$.checkResult(result, true)) {
              supplierList = result.data ? result.data.map(ele => {
                ele.cid = ele.supplierId
                return ele
              }) : [];
            }
            this.isLoading = false;
          });
        }
        this.modal.data = {
          selecteds: row ? supplierList : [],
          pids: row ? [row.pid] : this.portList
        };
      } else {
        $MessageBox.alert({ content: "请勾选接口!" });
        return false;
      }
      this.modal.template = "select-supplier";
      this.modal.title = "选择供应商";
      this.modal.show = true;
    },
    // 选择供应商回调
    $_callbackSupper(){
      this.$_getApis();
    },
  },

  components: {
    SelectSupplier,
    ModalModify,
    modalBatch,
    sendTypeTmpl: {
      template: `<span>{{row.sendType === 1 ? '转发' : row.sendType === 2 ? '分发' : '仅接收'}}</span>`,
      props: { row: { type: Object, required: true } }
    }
  },

  mounted() {
    let height = this.$refs.tableList.$el.parentElement.clientHeight;
    this.tableHeight = `${height}px`;
    /* const self = this;
    window.onresize = Utils.debounce(() => {
      let height = self.$refs.tableList.$el.parentElement.clientHeight;
      self.tableHeight = `${height}px`;
    }, 50) */
    this.$_getApis();
  }
};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  flex: auto;
  flex-direction: column;
  margin: 20px 16px 24px 20px;
  border: 1px solid #eee;
}
.page-main__wrapper {
  overflow: hidden;
  position: relative;
}

.filter-box {
  // min-height: 120px;
  color: #68768a;
  background-color: #f5f6f7;
  padding: 20px 20px 10px 20px;

  .top-btns {
    min-height: 52px;
  }
}

.table-box {
  height: 100vh;
  border-top: 1px solid #eee;
  overflow-x: auto;
  position: relative;
  // margin-bottom: 44px;
  .cd-switch{
    margin-right: 10px;
  }
}
</style>


